import React, {useState} from "react"
import { useParams} from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useUser } from "../../../Hooks/useUser";
import axios from "../../../api/axios";

const TeamCreate = (props) => {
    const user = useUser();
    const params = useParams();
    const eventid = params.eventid;
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [team, setTeam] = useState({
       BPEventID: parseInt(eventid),
       BPGroupName:'',
       BPGroupOwner: user?.user?.UserID,
       BPGroupSize:0,
     });

      function handleTeamInputChange(input){
        const target = input.target;
        const value = target.value;
        const name = target.id;
        setTeam({...team, [name]: value});
    }

    function handleTeamGroupSizeChange(input){
        const target = input.target;
        const value = parseInt(target.value);
        const name = target.id;
        setTeam({...team, BPGroupSize: value});
    }

    async function CreateTeam() {
    if (!team.BPGroupName) {
        enqueueSnackbar('Please enter a team name.');
        return;
    }

    try {
        const result = await axios.post('/api/groups/group', team);

        // Log this so you can see exactly what comes back
        //console.log('CreateTeam response:', result.data);

        if (result.data) {
            // Merge API response back into local state in case the server
            // assigns an ID or other fields (e.g. BPGroupID)
            const savedTeam = { ...team, ...result.data };
            setTeam(savedTeam);
            enqueueSnackbar('Team Created');
            props.onTeamReady(savedTeam); // send the full merged object up
        } else {
            enqueueSnackbar('Failed to create team. Please try again.');
        }
    } catch (err) {
        console.error('CreateTeam error:', err);
        enqueueSnackbar('An error occurred while creating the team.');
    }
}

    
      return(
        <div className="mb-4">
          <div className="full-row gray px-4 py-3 mb-4 rounded">
            <h5 className="mb-0 text-uppercase">Team Information</h5>
          </div>
          <div className="px-4 pb-3">
            <p className="mb-3">Please complete the following fields to set up your team.</p>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label className="required-caption"><span className="required-field">*</span>Team Name</label>
                  <input type="text" id='BPGroupName' maxLength="200" className="form-control" placeholder="Enter team name" value={team.BPGroupName} onChange={handleTeamInputChange} />
                  <small className="form-text text-muted">Enter a one word team name. For example, your last name, your church name, etc. Your team members will need this team name in order to register.</small>
                </div>
              </div>
              {/* <div className="col-md-6">
                <div className="form-group">
                  <label className="required-caption"><span className="required-field">*</span>Team Size</label>
                  <input type="number" id='BPGroupSize' maxLength="200" className="form-control" placeholder="Enter team size" value={team.BPGroupSize} onChange={handleTeamGroupSizeChange} />
                </div>
              </div> */}
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <a
                  className="button-default button-green"
                  onClick={CreateTeam}
                  role="button"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '40px',
                    minWidth: '160px',
                    cursor: 'pointer',
                  }}
                >
                  Create Team
                </a>
              </div>
            </div>
          </div>
        </div>
      )
    }


export default TeamCreate;